import { Outlet } from 'react-router-dom'

const NotificationCustomer = () => <Outlet />

export default NotificationCustomer
